import { render, staticRenderFns } from "./OrganismFeedSectionContent.vue?vue&type=template&id=46fcc8fa&scoped=true&"
import script from "./OrganismFeedSectionContent.vue?vue&type=script&lang=js&"
export * from "./OrganismFeedSectionContent.vue?vue&type=script&lang=js&"
import style0 from "./OrganismFeedSectionContent.vue?vue&type=style&index=0&id=46fcc8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcc8fa",
  null
  
)

export default component.exports